import axios from 'axios'
import { Message, MessageBox, Loading } from 'element-ui'
import router from '@/router'
import Cookies from 'js-cookie'

// create an axios instance
const service = axios.create({
  baseURL: process.env.BASE_API_URL, // api的base_url
  timeout: 5000, // request timeout
  // withCredentials: true,
  crossDomain: true
})

function getQueryVariable(qs) {
  var s = location.href.replace("?", "?&").split("&")
  var re = ""
  for (var i = 1; i < s.length; i++) {
    if (s[i].indexOf(qs + "=") == 0) {
      re = s[i].replace(qs + "=", "")
    }
  }
  return re
}

function uuid() {
  var uid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
    /[xy]/g,
    function (c) {
      var r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8
      return v.toString(16)
    }
  )
  return uid
}

// request interceptor
service.interceptors.request.use(config => {
  // Do something before request is sent
  // if (store.getters.token) {
  // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
  // config.headers['X-Token'] = getToken()
  // config.headers['userId'] = '0'

  // config.headers['token'] = 'Bearer eyJ0eXAiOiJKc29uV2ViVG9rZW4iLCJhbGciOiJIUzI1NiJ9.eyJuYW1lIjoi6LaF57qn566h55CG5ZGYIiwiaWNvbiI6Imh0dHA6Ly8xOTIuMTY4LjExMC4xNTIvZmlsZS96aG9uZ3RpYW4tdGVzdC10d28vY3JtL2E3MjRkNWRmLTY2MWMtNDBkOS04YWY4LTE4NzYzOWMxYjI5Mi5qcGVnIiwidG9rZW5fdHlwZSI6InRva2VuIiwidXNlcmlkIjoiMSIsInRlbmFudCI6Inpob25ndGlhbi10ZXN0LXR3byIsImNsaWVudF9pZCI6IjUiLCJleHAiOjE2MTg2NDc5OTgsIm5iZiI6MTYxODYxOTE5OH0.cTVnVBaIbn7D-vUcZXyPRjQQNeeIZy4uExvgL7Rr64g'
  if(Cookies.get('AccessToken')) {
    config.headers['access-token'] = JSON.parse(Cookies.get('AccessToken')).access_token
  } else {
    Cookies.remove('DeviceId')
  }
  if(Cookies.get('UserToken')) {
    config.headers['user-token'] = JSON.parse(Cookies.get('UserToken'))
    if(JSON.parse(Cookies.get('school_user_token'))) {
      config.headers['school-user-token'] = JSON.parse(Cookies.get('school_user_token'))
    }
  }
  config.headers['version'] = 'v3.0'
  if (config.responseType) {
    config.headers['responseType'] = 'blob'
  }
  

  // console.log("config.data:"+ config.data)
  // console.log("config.url:"+ config.url)
  // if (config.url === "/dzhtApi/startSignFlow") {
  //   config.headers['Content-Type'] = "application/x-www-form-urlencoded"
  // }
  return config
}, error => {
  // Do something with request error

  // console.log(error) // for debug
  Promise.reject(error)
})

// respone interceptor
service.interceptors.response.use(
  // response => response,
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过xmlhttprequest来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    const { type, responseType, getData } = response.config
    
    // -996
    if (response.data.code === -14) {
      Cookies.remove('UserToken')
      Cookies.remove('AccessToken')
      this.$router.push({path: '/login'})
    } else if (response.code == 40005) {
      MessageBox.confirm('系统正在维护', '系统繁忙', {
        confirmButtonText: '重新登录',
        type: 'warning'
      }).then(() => {
      })
    } else if (response.code == 404) {
      router.push('/post404')
    }
    // 构造上传接口的返回数据结构
    if (type === 'upload') {
      const { headers, data } = response
      return {
        headersData: headers.data ? JSON.parse(headers.data) : {},
        // resFileName: getFileName(response.headers['content-disposition']),
        bodyData: data
      }
    }
    // 构造下载接口的返回数据结构
    if (responseType === 'blob' && type === 'download') {
      if (response.status !== 201 && response.status !== 200) {
        Message({
          message: '下载失败',
          type: 'error',
          duration: 5 * 1000
        })
        return Promise.reject('error')
      }
      return {
        // fileName: getFileName(response.headers['content-disposition']),
        data: response.data
      }
    }
    const res = response.data
    if (!res.code) {
      if (getData) return res.data
      return res
    } else if (res.isSuccess == true) {
      if (getData) return res.data
      return res
    }
    if (res.code !== 1) {
      console.log(response.config)
      if(res.msg === '请退出小程序重新打开进入' || response.config.url.indexOf('628df7cecea3b') > -1) {
        console.log(res.msg)
      } else {
        Message({
          message: res.msg,
          type: 'error',
          duration: 5 * 1000
        })
      }
      // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      // if (res.code === '301' || res.code === 50008 || res.code === 50012 || res.code === 50014) {
      // if (sessionStorage.getItem("code") == '') {

      // 这里是不要注释的
      return Promise.reject('error')
    } else {
      return response.data

    }

  },
  error => {
    console.log(error, 'qweqwe')
    var res = error.response.data

    var url = '/login'
    // var url = router.history.current.path
    if (res.code === 40001) {
      MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
        confirmButtonText: '重新登录',
        type: 'warning'
      }).then(() => {
      })
    } else if (res.code == 40005) {
      MessageBox.confirm('系统正在维护', '系统繁忙', {
        confirmButtonText: '重新登录',
        type: 'warning'
      }).then(() => {
      })
    }

    var a = ''
    if (res.msg == '空指针异常') {
      var a = '系统正在更新，请稍后再试'
    } else if (res.msg) {
      var a = res.msg
    } else if (!res.msg) {
      var a = '系统繁忙！'
    }
    if (document.getElementsByClassName('el-message').length > 0) return Promise.reject(error);
    Message({
      message: a,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)

  })

export default service



// WEBPACK FOOTER //
// ./src/js/req.js